import * as noUiSlider from '../../lib/rangeslider/rangeslider.js';

/** @module filter */

/**
 * Funktionalität des Filter-Typ "Range".
 */

const classVisuallyHidden = 'is-visuallyhidden';
const classOpcFilter = 'opc-filter';

export class RangeFilter {
	constructor(item, wrapper, opaccFilterCriterias) {
		this.filterItem = item;
		this.wrapperItem = wrapper;
		this.opaccFilterCriterias = opaccFilterCriterias;
		if (this.wrapperItem) {
			let itemId = `#${this.filterItem.getAttribute('id')}`;
			this.sliderHandler = this.wrapperItem.querySelector(`${itemId}-slider`);
            this.sliderBtn = this.filterItem.querySelector(`${itemId}-apply-btn`);
            this.sliderInputFrom = this.filterItem.querySelector(`${itemId}-from`);
            this.sliderInputTo = this.filterItem.querySelector(`${itemId}-to`);
            this.sliderValues = [
				this.sliderInputFrom,
				this.sliderInputTo
			];
            this.inputHandler = this.wrapperItem.querySelector(`${itemId}-input`);
            this.filterType = this.filterItem.dataset.opFiltertype;

			this.displaySliderValues = undefined;
			this.rangeSeparator = undefined;
			this.defaultDec = 2;

			if (this.wrapperItem.querySelector(`${itemId}-combined-range`)) {
				this.displaySliderValues = [
					this.wrapperItem.querySelector(`${itemId}-combined-range .combined-from`),
					this.wrapperItem.querySelector(`${itemId}-combined-range .combined-to`)
				];
				this.rangeSeparator = this.wrapperItem.querySelector(`${itemId}-combined-range .range-separator`);
			}

			if (this.sliderHandler) {
				this.sliderOptions = JSON.parse(this.sliderHandler.dataset.opSliderOptions);
				if (Object.prototype.hasOwnProperty.call(this.sliderOptions, 'dec')) {
					this.appendDecFormat();
				}

				this.createSlider();
			}

            if (this.inputHandler) {
                this.inputOptions = JSON.parse(this.inputHandler.dataset.opInputOptions);
                if (Object.prototype.hasOwnProperty.call(this.inputOptions, 'dec')) {
                    this.appendDecFormat();
                }

                this.attachInputEvents(this.sliderValues, this.inputOptions);
                this.attachButtonEvents(this.sliderValues, this.inputHandler, this.inputOptions);
            }
		}
	}


	/**
	 *
	 *
	 */
	appendDecFormat() {
		let dec = +this.sliderOptions.dec >= 0 ? +this.sliderOptions.dec : this.defaultDec;
		this.sliderOptions = Object.assign(this.sliderOptions, { format: { from: null, to: null } });
		this.sliderOptions.format.from = function(value) {
			return parseFloat(value).toFixed(dec);
		};

		this.sliderOptions.format.to = function(value) {
			return parseFloat(value).toFixed(dec);
		};
	}

	/**
	 *
	 *
	 */
	createSlider() {
		noUiSlider.create(this.sliderHandler, this.sliderOptions);
		this.updateSliderFields(this.sliderValues, this.sliderHandler, this.displaySliderValues, this.rangeSeparator, this.filterType);
	}

	/**
	 *
	 *
	 * @param {*} sValues
	 * @param {*} sHandler
	 * @param {*} sDisplay
	 * @param {*} sSeparator
	 */
	updateSliderFields(sValues, sHandler, sDisplay, sSeparator, sFilterType) {
		this.attachSliderEvents(sValues, sHandler);

		sHandler.noUiSlider.on('update', function (values, handle) {
            let valueIndex = handle;
            if (sFilterType == 'E') {
                valueIndex = 1;
            }
			sValues[valueIndex].value = values[handle];
			if (sDisplay) {
				sDisplay[handle].innerHTML = values[valueIndex];
			}

			if (sSeparator) {
				const equals = sValues.every(function (field, index, sValues) {
					return field.value === sValues[0].value;
				});

				if (equals) {
					sSeparator.classList.add(classVisuallyHidden);
					sDisplay[0].classList.add(classVisuallyHidden);
				} else {
					sSeparator.classList.remove(classVisuallyHidden);
					sDisplay[0].classList.remove(classVisuallyHidden);
				}
			}
		});

		sHandler.noUiSlider.on('change', values => {
			if (sDisplay) {
				this.changeFilterCriteria(sHandler, values);
			}
		});
	}

	/**
	 *
	 *
	 * @param {*} sValues
	 * @param {*} sHandler
	 */
	attachSliderEvents(sValues, sHandler) {
		sValues.forEach(item => {
            if (item) {
			    item.addEventListener('change', () => {
				    sHandler.noUiSlider.set([sValues[0]?.value,sValues[1]?.value]);
			    });
            }
		});

        this.attachButtonEvents(sValues, sHandler);
	}

     /**
     *
     *
     * @param {*} sValues
     * @param {*} sHandler
     */
     attachButtonEvents(sValues, sHandler, iOptions) {
        if (this.sliderBtn) {
            let updateFilterCriteria = () => {
                this.checkValuesOnEvent(sValues, sHandler, iOptions);
                this.changeFilterCriteria(sHandler, [sValues[0]?.value,sValues[1]?.value]);
            };
            let updateOnKeyEvent = event => {
                if (event.keyCode === 13) {
                    updateFilterCriteria();
                }
            };

            this.sliderBtn.onclick = updateFilterCriteria;

            if (this.sliderInputFrom) {
                this.sliderInputFrom.onkeyup = updateOnKeyEvent;
            }
            if (this.sliderInputTo) {
                this.sliderInputTo.onkeyup = updateOnKeyEvent;
            }
        }
    }

    /**
     *
     *
     * @param {*} sValues
     * @param {*} iOptions
     */
    attachInputEvents(sValues, iOptions) {
        let inputBlurEvent = event => {
            let minValue = iOptions.range.min;
            let maxValue = iOptions.range.max;

            if (event.target.id === sValues[0].id && (this.valueOperationCheck(event.target.value, minValue, 'min') || event.target.value.trim() === '')) {
                event.target.value = minValue;
            }

            if (event.target.id === sValues[1].id && (this.valueOperationCheck(event.target.value, maxValue, 'max') || event.target.value.trim() === '')) {
                event.target.value = maxValue;
            }
        };

        if (this.sliderInputFrom) {
            this.sliderInputFrom.onblur = inputBlurEvent;
        }
        if (this.sliderInputTo) {
            this.sliderInputTo.onblur = inputBlurEvent;
        }
    }

         /**
     *
     *
     * @param {*} sValues
     * @param {*} sHandler
     * @param {*} iOptions
     */
    checkValuesOnEvent(sValues, sHandler, iOptions) {
        if (!this.inputHandler || sHandler.id !== this.inputHandler.id) {
            return
        }

        let minValue = iOptions.range.min;
        let maxValue = iOptions.range.max;

        if (this.valueOperationCheck(sValues[0].value, minValue, 'min') || sValues[0].value.trim() === '') {
            sValues[0].value = minValue;
        }

        if (this.valueOperationCheck(sValues[1].value, maxValue, 'max') || sValues[1].value.trim() === '') {
            sValues[1].value = maxValue;
        }
    }

    /**
     *
     *
     * @param {*} sHandler
     * @param {*} values
     */
    changeFilterCriteria(sHandler, values) {
        let valueConcat = `[${values.join('|')}]`;
        let filterDiv = sHandler.closest(`.${classOpcFilter}`);
        this.opaccFilterCriterias.change(sHandler.dataset.opFilterattr, valueConcat, true, filterDiv.dataset.opGroupid, filterDiv.id);
    }

    /**
	 *
	 *
	 * @param {*} value
	 * @param {*} other
     * @param {*} operator
	 */
    valueOperationCheck(value, other, operator) {
        if (value === other) {
            return false;
        }

        let valueArr = this.getCharCodeArray(value.toLowerCase());
        let otherArr = this.getCharCodeArray(other.toLowerCase());
        let length = valueArr.length > otherArr.length ? valueArr.length : otherArr.length

        for (let i=0; i<length; i++) {
            if (operator === 'min') {
                if (valueArr[i]<otherArr[i]) {
                    return true;
                }
                if (valueArr[i]>otherArr[i]) {
                    return false;
                }
            }
            if (operator === 'max') {
                if (valueArr[i]>otherArr[i]) {
                    return true;
                }
                if (valueArr[i]<otherArr[i]) {
                    return false;
                }
            }
        }

        return false;
    }

    /**
     *
     *
     * @param {*} value
     */
    getCharCodeArray(value) {
        let valueArr = []
        for (let i=0; i<value.length; i++) {
            valueArr.push(value.charCodeAt(i));
        }

        return valueArr
    }
}